<script>
  import _ from 'lodash'
  import moment from 'moment'
  import Cleave from 'cleave.js'
  import ranger from '../shared/ranger'

  export default {
    name: 'VDateRange',
    props: {
      value: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    data() {
      return {
        dialog: false,
        tsdialog: false,
        tedialog: false,
        start: null,
        end: null,
        stime: null,
        etime: null,
        today: moment().format('YYYY-MM-DD')
      }
    },

    computed: {
      mainClasses() {
        return this.ranger.duration && this.ranger.duration.asMonths() < 2
          ? 'v-date-range--hide-outside'
          : ''
      },

      withTime() {
        return this.$attrs.time
      },

      ranger() {
        return ranger.create('d', this.value)
      },

      range() {
        return this.ranger.keys.map(range => range.key)
      },

      mranger() {
        return ranger.create('m', this.value)
      },
      mrange() {
        return this.mranger.keys.map(range => {
          return {
            key: range.key,
            analyze: ranger.analyze(range)
          }
        })
      },

      duration: {
        get() {
          return (
            this.ranger.strings.isoDuration +
            (this.withTime ? this.ranger.strings.isoDurationTime : '')
          )
        },
        set(d) {
          const newrange = ranger.duration(this.value, d)
          this.$emit('change', newrange)
        }
      },
      humanize() {
        const humanize = _.get(this.ranger, 'strings.humanize', '')
        const humanizeTime = this.withTime ? ' ' + this.ranger.strings.humanizeTime : ''
        return humanize ? `${humanize}${humanizeTime}` : ''
      },

      globalDef() {
        return {
          filled: this.$attrs.filled,
          outlined: this.$attrs.outlined,
          solo: this.$attrs.solo,
          dense: this.$attrs.dense,
          clearable: true,
          readonly: false,
          hideDetails: true,
          persistentHint: true,
          locale: this.$vuetify.lang.current === 'de' ? 'de-de' : 'en-us'
        }
      },
      startDef() {
        return {
          ...this.globalDef,
          label: 'von',
          format: 'YYYY-MM-DD',
          clearable: true,
          prependInnerIcon: 'mdi-calendar-range'
        }
      },
      endDef() {
        return {
          ...this.globalDef,
          format: 'YYYY-MM-DD',
          label: 'bis',
          clearable: true,
          prependInnerIcon: 'mdi-calendar-range'
        }
      },
      stimeDef() {
        return {
          ...this.globalDef,
          label: 'um',
          format: 'HH:mm',
          prependInnerIcon: 'mdi-clock-outline'
        }
      },
      etimeDef() {
        return {
          ...this.globalDef,
          label: 'um',
          format: 'HH:mm',
          prependInnerIcon: 'mdi-clock-outline'
        }
      },

      globalCalDef() {
        return {
          type: 'month',
          weekdays: [1, 2, 3, 4, 5, 6, 0],
          locale: 'de-de'
        }
      },
      scalDef() {
        return {
          ...this.globalCalDef
        }
      },
      ecalDef() {
        return {
          ...this.globalCalDef
        }
      },

      getTitleStart() {
        const label = ''
        return `${label}${this.getTitle(this.ranger.start)}`
      },
      getTitleEnd() {
        const label = ''
        return `${label}${this.getTitle(this.ranger.end)}`
      }
    },
    watch: {
      start(_start) {
        const date = ranger.parseDate(_start)
        if (date) {
          this.ranger.start = this.ranger.start || moment()
          this.ranger.start.set(date)
          this.update()
        }
      },
      end(_end) {
        const date = ranger.parseDate(_end)
        if (date) {
          this.ranger.end = this.ranger.end || moment()
          this.ranger.end.set(date)
          this.update()
        }
      },
      stime(_stime) {
        const time = ranger.parseTime(_stime)
        if (time) {
          this.ranger.start.set(time)
          this.update()
        }
      },
      etime(_etime) {
        const time = ranger.parseTime(_etime)
        if (time) {
          this.ranger.end.set(time)
          this.update()
        }
      }
    },

    created() {
      this.init()
    },

    updated() {
      if (!this.withTime) {
        this.ranger.start.set({ hour: 0, minute: 0, second: 0 })
        this.ranger.end.set({ hour: 23, minute: 59, second: 59 })
        this.update()
      }
    },

    mounted() {
      this.$nextTick(() => {
        const startInput = _.get(this.$refs, 'start.$refs.input')
        if (startInput) {
          const cleaveStart = new Cleave(startInput, {
            date: true,
            datePattern: ['Y', 'm', 'd'],
            delimiter: '-'
          })
        }
        const startTimeInput = _.get(this.$refs, 'stime.$refs.input')
        if (startTimeInput) {
          const cleaveStartTime = new Cleave(startTimeInput, {
            time: true,
            timePattern: ['h', 'm']
          })
        }
        const endInput = _.get(this.$refs, 'end.$refs.input')
        if (endInput) {
          const cleaveEnd = new Cleave(endInput, {
            date: true,
            datePattern: ['Y', 'm', 'd'],
            delimiter: '-'
          })
        }
        const endTimeInput = _.get(this.$refs, 'etime.$refs.input')
        if (endTimeInput) {
          const cleaveEndTime = new Cleave(endTimeInput, {
            time: true,
            timePattern: ['h', 'm']
          })
        }
      })
    },

    methods: {
      init() {
        const {start, end} = this.ranger
        this.start = start ? start.format('YYYY-MM-DD') : ''
        this.end = end ? end.format('YYYY-MM-DD') : ''
        this.stime = start ? start.format('HH:mm') : ''
        this.etime = end ? end.format('HH:mm') : ''
      },

      update() {
        const [cstart, cend] = this.value
        const {start, end} = this.ranger
        const from = start && start.format()
        const to = end && end.format()
        if (from !== cstart || to !== cend) {
          // if (from !== cstart) console.log('from', from, cstart)
          // if (to !== cend) console.log('to', to, cend)
          this.$emit('change', [from, to])
        }
      },

      getWeekday(cc) {
        return moment(cc.date).format('ddd')
      },
      getMonth(cc) {
        return moment(cc.date).format('MMM')
      },
      getTime(cc) {
        return cc.time
      },

      getYear(dte) {
        return moment(dte).format('YYYY')
      },
      getWeek(dte) {
        return moment(dte).format('WW')
      },

      getTitle(dte) {
        const mom = moment(dte)
        const y = mom.format('YYYY')
        const w = mom.format('W')
        const d = mom.format('D')
        const m = mom.format('MMMM')
        const t = mom.format('HH:mm')
        return `${y} (${w}) ${d}. ${m} ${t}`
      },

      inRange(date) {
        return this.range.includes(date)
      },

      onClickDayStart(cc) {
        this.start = cc.date
      },
      onClickDayEnd(cc) {
        this.end = cc.date
      },

      onMonthScroll(sc) {
        console.log('sc', sc)
      },

      onCalNav(ct, mode) {
        const cal = this.$refs[`${ct}_calendar`]
        if (!cal) return

        switch (mode) {
          case 'next':
            return cal.next()
          case 'prev':
            return cal.prev()
        }
      },

      onSave() {
        // TODO check for cancel to restore old value
        this.update()
        this.$refs.dialog.save()
      }
    }
  }
</script>

<template>
  <div>
    <VLayout>
      <VFlex xs12 sm12 md8 class="pr-2 py-1">
        <VTextField ref="start" v-model="start" v-bind="startDef" @click:prepend-inner="dialog = !dialog"/>
      </VFlex>
      <VFlex v-if="withTime" xs12 sm12 md4 class="pl-2 py-1">
        <VTextField ref="stime" v-model="stime" v-bind="stimeDef" @click:prepend-inner="tsdialog = !tsdialog"/>
        <VDialog
          ref="tsdialog"
          v-model="tsdialog"
          :return-value.sync="stime"
          persistent
          width="290"
        >
          <VTimePicker v-model="stime" format="24hr">
            <VSpacer/>
            <VBtn text color="primary" @click="tsdialog = false">{{ $vuetify.lang.t('$vuetify.actions.cancel') }}</VBtn>
            <VBtn text color="primary" @click="$refs.tsdialog.save(stime)">{{ $vuetify.lang.t('$vuetify.actions.ok') }}</VBtn>
          </VTimePicker>
        </VDialog>
      </VFlex>
    </VLayout>

    <VLayout>
      <VFlex xs12 sm12 md8 class="pr-2 py-1">
        <VTextField ref="end" v-model="end" v-bind="endDef" @click:prepend-inner="dialog = !dialog"/>
      </VFlex>
      <VFlex v-if="withTime" xs12 sm12 md4 class="pl-2 py-1">
        <VTextField ref="etime" v-model="etime" v-bind="etimeDef" @click:prepend-inner="tedialog = !tedialog"/>
        <VDialog ref="tedialog" v-model="tedialog" :return-value.sync="etime" persistent width="290">
          <VTimePicker v-model="etime" format="24hr">
            <VSpacer/>
            <VBtn text color="primary" @click="tedialog = false">{{ $vuetify.lang.t('$vuetify.actions.cancel') }}</VBtn>
            <VBtn text color="primary" @click="$refs.tedialog.save(etime)">{{ $vuetify.lang.t('$vuetify.actions.ok') }}</VBtn>
          </VTimePicker>
        </VDialog>
      </VFlex>
    </VLayout>

    <VLayout>
      <VFlex xs12 sm12 md12>
        <div class="v-date-range__humanize ml-4">{{ humanize }}</div>
      </VFlex>
    </VLayout>

    <VDialog ref="dialog" v-model="dialog" persistent width="90%">
      <!--Dialog content-->
      <VSheet v-model="start" class="v-date-range" :class="mainClasses">
        <VContainer fluid fill-height py-0>
          <VLayout class="v-date-range__layout" column>
            <VLayout row>
              <VFlex pa-2>
                <VLayout column>
                  <VToolbar flat color="transparent">
                    <VToolbarTitle>{{ getTitleStart }}</VToolbarTitle>
                    <VSpacer/>
                    <VBtn icon text @click="onCalNav('s', 'prev')">
                      <VIcon>mdi-chevron-left</VIcon>
                    </VBtn>
                    <VBtn icon text @click="onCalNav('s', 'next')">
                      <VIcon>mdi-chevron-right</VIcon>
                    </VBtn>
                  </VToolbar>
                  <VCalendar
                    ref="s_calendar"
                    v-model="start"
                    v-bind="scalDef"
                    class="v-date-range__calender"
                    start="2010-01-01"
                    :end="end"
                    :weekday-format="getWeekday"
                    :month-format="getMonth"
                    :interval-format="getTime"
                    @click:day="onClickDayStart"
                  >
                    <VLayout slot="day" slot-scope="{ present, past, date }" class="fill-height">
                      <VSheet v-if="inRange(date)" class="v-date-range__inrange" color="accent" tile/>
                    </VLayout>
                  </VCalendar>
                </VLayout>
              </VFlex>

              <!--Month overview-->
              <VFlex pa-2 shrink style="overflow:hidden">
                <VToolbar flat color="transparent">
                  <VToolbarTitle>Month</VToolbarTitle>
                  <VSpacer/>
                </VToolbar>
                <div class="v-data-range__month-scroll">
                  <template v-for="(month, idx) in mrange">
                    <VSheet :key="month.key" class="v-date-range__mrange">
                      <div class="v-data-range__mrange-key">
                        <div>{{ month.key }}</div>
                        <div>{{ month.analyze.days }}</div>
                      </div>
                      <div
                        class="v-data-range__selected accent"
                        :data-idx="idx"
                        :style="{
                          height: month.analyze.selected + '%',
                          top: idx === 0 ? 'inherit' : 0
                        }"
                      ></div>
                    </VSheet>
                  </template>
                </div>
              </VFlex>

              <VFlex pa-2>
                <VLayout column>
                  <VToolbar flat color="transparent">
                    <VToolbarTitle>{{ getTitleEnd }}</VToolbarTitle>
                    <VSpacer/>
                    <VBtn icon text @click="onCalNav('e', 'prev')">
                      <VIcon>mdi-chevron-left</VIcon>
                    </VBtn>
                    <VBtn icon text @click="onCalNav('e', 'next')">
                      <VIcon>mdi-chevron-right</VIcon>
                    </VBtn>
                  </VToolbar>
                  <VCalendar
                    ref="e_calendar"
                    v-model="end"
                    v-bind="ecalDef"
                    class="v-date-range__calender"
                    :weekday-format="getWeekday"
                    :month-format="getMonth"
                    :interval-format="getTime"
                    @click:day="onClickDayEnd"
                  >
                    <VLayout slot="day" slot-scope="{ present, past, date }" class="fill-height">
                      <VSheet v-if="inRange(date)" class="v-date-range__inrange" color="accent" tile/>
                    </VLayout>
                  </VCalendar>
                </VLayout>
              </VFlex>
            </VLayout>

            <VFlex shrink>
              <VLayout>
                <VFlex xs6 sm6 md4 lg3>
                  <VTextField
                    v-model="duration"
                    class="pl-3"
                    label="Dauer (ISO 8601)"
                    hint="PnYnMnDTnHnMnS or PnW"
                    persistent-hint
                    solo
                    prepend-inner-icon="mdi-calendar-range"
                    spellcheck="false"
                  />
                </VFlex>
              </VLayout>
              <VLayout class="align-end">
                <VFlex grow pa-3>{{ humanize }}</VFlex>
                <VSpacer/>
                <VFlex shrink>
                  <VBtn text @click="dialog = false">{{ $vuetify.lang.t('$vuetify.actions.cancel') }}</VBtn>
                  <VBtn text outlined color="primary" @click="onSave">{{ $vuetify.lang.t('$vuetify.actions.ok') }}</VBtn>
                </VFlex>
              </VLayout>
            </VFlex>
          </VLayout>
        </VContainer>
      </VSheet>
    </VDialog>
  </div>
</template>

<style lang="scss" scoped>
  .v-date-range {
    position: relative;
    height: 75vh;

    .v-date-range__calender {
      height: 480px;
    }

    .v-date-range__inrange {
      width: 120%;
      height: 10px;
      margin-right: -8px;
      margin-left: -8px;
    }

    .v-data-range__month-scroll {
      height: 85%;
      overflow: auto;
    }
    .v-date-range__mrange {
      position: relative;
      width: 48px;
      height: 48px;
      margin-bottom: 4px;
      text-align: center;
      background: #f7f7f7;
      border: 1px solid #ccc;

      > div {
        width: 100%;
        font-size: 11px;
      }
      .v-data-range__mrange-key {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        z-index: 3;
      }
      .v-data-range__selected {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 0;
      }
    }
  }

  .v-date-range__humanize {
    font-size: 11px;
    text-align: left;
  }
</style>
<style lang="scss">
  .v-date-range.v-date-range--hide-outside .v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
    background-color: inherit;
  }
  .v-date-range.v-date-range--hide-outside .v-calendar-weekly .v-calendar-weekly__day.v-outside {
    background-color: inherit;
  }
  .v-date-range.v-date-range--hide-outside .v-outside > * {
    visibility: hidden;
  }
  .v-date-range .v-calendar-weekly .v-calendar-weekly__day:first-of-type {
    border-left: 1px solid #e0e0e0;
  }
  .v-date-range .v-toolbar__content {
    padding-right: 0;
    padding-left: 0;
  }
</style>
